import React from 'react'
import AddBilling from '../addEditAddress/AddBilling'
import styles from './profilebody.module.css';

const AddressTable = ({customer,handleEditClick,heading,addressData}) => {
    return (
        <>
            {addressData?.map((address, index) => (
                <div className={styles.address_box} key={address?._id || `${heading}-${index}`}>
                    <div className={styles.addressCardHeader}>
                        <div>
                            <span className={styles.addressType}>{heading} address</span>
                            <div className={styles.h3}>{address?.factoryUnits || `${heading} address`}</div>
                        </div>
                        <button className={styles.editbtn} onClick={() => handleEditClick(address)}>Edit</button>
                    </div>
                    <div className={styles.address_deets}>
                        <p className={styles.addressLine}>{[address?.streetAddress, address?.state, address?.country, address?.zipCode].filter(Boolean).join(', ')}</p>
                        <div className={styles.addressContactGrid}>
                            <p><span>Email</span>{customer?.email || '—'}</p>
                            <p><span>Phone</span>{customer?.phone || '—'}</p>
                        </div>
                    </div>
                </div>
            ))
            }
        </>
    )
}

export default AddressTable
